// extracted by mini-css-extract-plugin
export default {"segment":"ModeSegment_segment__82ESg","option":"ModeSegment_option__V6Knb","optionActive":"ModeSegment_optionActive__tyqU-","icon":"ModeSegment_icon__bwORV"};